var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 116,
    viewBox: "0 0 124 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_13605_24307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.002 54.8415C107.002 79.0494 87.2206 98.6798 62.8209 98.6798C55.0713 98.6798 47.7932 96.7023 41.4645 93.2252L17.002 101L24.9748 77.4806C20.9507 70.8722 18.6368 63.1256 18.6368 54.8446C18.6368 30.6273 38.4181 11 62.8209 11C87.2238 11 107.002 30.6273 107.002 54.8415ZM62.8209 17.9826C42.3322 17.9826 25.6728 34.5163 25.6728 54.8415C25.6728 62.9024 28.2979 70.3723 32.7465 76.4525L28.1093 90.1379L42.3825 85.6044C48.2459 89.4525 55.2725 91.6972 62.8209 91.6972C83.3002 91.6972 99.9659 75.1636 99.9659 54.8415C99.9659 34.5194 83.3002 17.9826 62.8209 17.9826ZM85.1299 64.9396C84.8564 64.4901 84.1333 64.2228 83.055 63.6852C81.9703 63.1476 76.6446 60.5476 75.6511 60.1892C74.6608 59.8308 73.9314 59.6516 73.2146 60.7268C72.4915 61.802 70.4166 64.2228 69.7815 64.9396C69.1527 65.6596 68.5208 65.7445 67.4393 65.2069C66.3547 64.6693 62.8618 63.5312 58.7276 59.8748C55.5114 57.0233 53.3358 53.5085 52.7008 52.4333C52.072 51.3581 52.6379 50.7796 53.1755 50.242C53.6628 49.7578 54.2601 48.9876 54.8009 48.3619C55.3448 47.7332 55.524 47.2804 55.8855 46.5636C56.2471 45.8468 56.0679 45.2212 55.7944 44.6836C55.5271 44.146 53.3578 38.858 52.4555 36.7044C51.5595 34.5571 50.6541 34.6357 50.019 34.6357C49.384 34.6357 48.2207 34.8244 48.2207 34.8244C48.2207 34.8244 46.0483 35.0916 45.058 36.1668C44.0677 37.242 41.2696 39.842 41.2696 45.1269C41.2696 50.4117 45.146 55.5268 45.6899 56.2405C46.2338 56.9605 53.1786 68.1653 64.1917 72.4661C75.2016 76.7669 75.2016 75.3333 77.1885 75.151C79.1723 74.9749 83.5957 72.5541 84.498 70.0422C85.4003 67.5333 85.4003 65.3798 85.1331 64.9334L85.1299 64.9396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8209 17.9826C42.3322 17.9826 25.6728 34.5163 25.6728 54.8415C25.6728 62.9024 28.2979 70.3723 32.7465 76.4525L28.1093 90.1379L42.3825 85.6044C48.2459 89.4525 55.2725 91.6972 62.8209 91.6972C83.3002 91.6972 99.9659 75.1636 99.9659 54.8415C99.9659 34.5194 83.3002 17.9826 62.8209 17.9826ZM83.055 63.6852C84.1333 64.2228 84.8564 64.4901 85.1299 64.9396L85.1331 64.9334C85.4003 65.3798 85.4003 67.5333 84.498 70.0422C83.5957 72.5541 79.1723 74.9749 77.1885 75.151C75.2016 75.3333 75.2016 76.7669 64.1917 72.4661C53.1786 68.1653 46.2338 56.9605 45.6899 56.2405C45.146 55.5268 41.2696 50.4117 41.2696 45.1269C41.2696 39.842 44.0677 37.242 45.058 36.1668C46.0483 35.0916 48.2207 34.8244 48.2207 34.8244C48.2207 34.8244 49.384 34.6357 50.019 34.6357C50.6541 34.6357 51.5595 34.5571 52.4555 36.7044C53.3578 38.858 55.5271 44.146 55.7944 44.6836C56.0679 45.2212 56.2471 45.8468 55.8855 46.5636C55.524 47.2804 55.3448 47.7332 54.8009 48.3619C54.2601 48.9876 53.6628 49.7578 53.1755 50.242C52.6379 50.7796 52.072 51.3581 52.7008 52.4333C53.3358 53.5085 55.5114 57.0233 58.7276 59.8748C62.8618 63.5312 66.3547 64.6693 67.4393 65.2069C68.5208 65.7445 69.1527 65.6596 69.7815 64.9396C70.4166 64.2228 72.4915 61.802 73.2146 60.7268C73.9314 59.6516 74.6608 59.8308 75.6511 60.1892C76.6446 60.5476 81.9703 63.1476 83.055 63.6852Z",
    fill: "#4AC14B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_13605_24307",
    x: 7,
    y: 6,
    width: 110.002,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.4 0 0 0 0 0.458824 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13605_24307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_13605_24307",
    result: "effect2_dropShadow_13605_24307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13605_24307",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.fdb2d36660189f8d02cdda363dfe48e3.svg";
export { ForwardRef as ReactComponent };